export default __webpack_public_path__ + "static/media/vocab_light.8ee292cf.svg";